import React, { Fragment } from "react"
import { Text, View, StyleSheet } from "@react-pdf/renderer"
import formatNumberWithCommas from "../../../../../utils/formatNumberWithCommas"
import markUpCalc from "../../../../../utils/markUpCalc"

// Create styles
const styles = StyleSheet.create({
  roleHeader: {
    borderRadius: "4px",
    padding: "5px 10px",
    backgroundColor: "#FAF7F7",
  },
  itemWrapper: {
    backgroundColor: "#FFF0EF",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    borderRadius: "4px",
    padding: "5px 10px",
    margin: "1px 0 0 20px",
  },
  expenseRow: {
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
  },
  expenseName: {
    width: "60%",
  },
  expenseNumberItem: {
    width: "20%",
    textAlign: "right",
  },
})

const PdfTable = ({ position = {}, hasLineDiscounts = false }) => {
  // if invoice, parent component ClientPdf pools together additional & regular expenses into expenses
  // otherwise just gives regular

  //we create this fake crew to add any expense that is not attached to a crew
  const isMiscExpenses =
    position.first_name === "Misc" && position.last_name === "Expenses"




  return (
    <Fragment>
      <View style={styles.roleHeader}>
        <Text key={position.user_id}>
          {!isMiscExpenses && position.name}
          {!isMiscExpenses && ":"} {position.first_name} {position.last_name}
        </Text>
      </View>
      {/* map over expenses... */}
      <View style={{ marginBottom: "10px" }}>
        {position &&
          position.expenses.map((exp, i) => {
            return (
              <View key={i} style={styles.itemWrapper}>
                <View style={styles.expenseRow}>
                  <Text style={styles.expenseName}>{exp.type_name}</Text>
                  <Text>{exp.quantity}</Text>
                  <Text style={styles.expenseNumberItem}>
                    {exp.is_percentage
                      ? formatNumberWithCommas(
                        Number(exp.actual_rate * (exp.client_rate / 100)) +
                        Number(exp.actual_rate)
                      )
                      : formatNumberWithCommas(
                        (exp.quantity > 0
                          ? Number(exp.client_rate / exp.quantity)
                          : Number(exp.client_rate)) + Number(exp.actual_rate)
                      )}
                  </Text>
                  {hasLineDiscounts && (
                    <Text style={styles.expenseNumberItem}>
                      {exp.discount > 0 &&
                        `$ - ${formatNumberWithCommas(exp.discount)}`}
                    </Text>
                  )}
                  <Text style={styles.expenseNumberItem}>
                    $
                    {exp.is_percentage
                      ? formatNumberWithCommas(
                        Number(exp.actual_rate) * Number(exp.quantity) +
                        markUpCalc(
                          exp.quantity * exp.actual_rate,
                          exp.client_rate
                        ) -
                        Number(exp.discount)
                      )
                      : formatNumberWithCommas(
                        (exp.quantity > 0 ? Number(exp.client_rate) : 0) +
                        (Number(exp.actual_rate) * Number(exp.quantity) -
                          Number(exp.discount))
                      )}
                  </Text>
                </View>
                <View style={[styles.expenseRow, { marginTop: "5px" }]}>
                  <Text style={styles.expenseName}>{exp.description}</Text>
                </View>
              </View>
            )
          })}
        {/* Display no expenses message if role has none */}
        {position.expenses.length === 0 && (
          <View style={styles.expenseRow}>
            <Text style={{ width: "100%" }}>
              No expenses tied to this role.
            </Text>
          </View>
        )}
      </View>
    </Fragment>
  )
}

export default PdfTable
